import { render, staticRenderFns } from "./TicketsManager.vue?vue&type=template&id=3c554818&scoped=true"
import script from "./TicketsManager.vue?vue&type=script&lang=js"
export * from "./TicketsManager.vue?vue&type=script&lang=js"
import style0 from "./TicketsManager.vue?vue&type=style&index=0&id=3c554818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c554818",
  null
  
)

export default component.exports